import React, { useState } from "react";
import { PlayCircle } from "lucide-react";
import { SHOWREEL } from "@/lib/lime-data";

export default function Showreel() {
  const [playing, setPlaying] = useState(false);

  return (
    <section id="showreel" className="py-24 sm:py-32 border-t border-[#262626]" data-testid="showreel-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end mb-10">
          <div className="md:col-span-8">
            <div className="font-mono-overline text-[#E4FF00]">Showreel · 60s</div>
            <h2 className="font-display text-4xl sm:text-6xl font-black tracking-tighter mt-3 leading-[0.9]">
              See the space<br/>in motion.
            </h2>
          </div>
          <p className="md:col-span-4 text-sm text-[#A3A3A3] leading-relaxed">
            Watch some of the works shot at LIME Studios.
          </p>
        </div>

        <div
          className="relative aspect-video w-full border border-[#262626] overflow-hidden cursor-pointer group"
          onClick={() => setPlaying(true)}
          data-testid="showreel-player"
        >
          {!playing ? (
            <>
              <img
                src={SHOWREEL.poster}
                alt={SHOWREEL.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/70" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <span className="absolute -inset-6 rounded-full bg-[#E4FF00]/30 blur-2xl animate-pulse" />
                  <PlayCircle className="relative h-24 w-24 text-[#E4FF00] transition-transform duration-300 group-hover:scale-110" strokeWidth={1.2} />
                </div>
              </div>
              <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end">
                <div>
                  <div className="font-mono-overline text-[#E4FF00]">Press play</div>
                  <div className="font-display text-xl sm:text-2xl font-black mt-1">{SHOWREEL.title}</div>
                </div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3]">04K · HDR</div>
              </div>
            </>
          ) : (
            <iframe
              src={SHOWREEL.embed}
              title={SHOWREEL.title}
              className="absolute inset-0 w-full h-full"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>
    </section>
  );
}
